import type { MutableRefObject } from 'react';
import type { UseFloatingReturn } from '@floating-ui/react';
import { create } from 'zustand';

type TooltipState = {
    isOpen: boolean;
    floatState: UseFloatingReturn;
    arrowRef: MutableRefObject<null>;
};

type TooltipStore = {
    tooltips: Partial<Record<string, TooltipState>>;
    setOpen: (id: string, open: boolean) => void;
};

const useTooltipStore = create<TooltipStore>((set) => ({
    tooltips: {},
    setOpen: (id, open) =>
        set((state) => {
            const prevState = state.tooltips[id] || ({} as TooltipState);
            return { tooltips: { ...state.tooltips, [id]: { ...prevState, isOpen: open } } };
        })
}));

export default useTooltipStore;
